'use strict';
import {combineReducers} from 'redux';
import {reduxList as assetsProjectsList} from '../redux/assetsProjectsList';
import {createAssetRequestModal} from '../redux/createAsset';
import {deleteAssetRequest} from '../redux/deleteAsset';
import {ASSETS_PROJECTS_LIST_NAME, CREATE_ASSET_NAME, DELETE_ASSET_NAME, UPDATE_ASSET_NAME} from '../redux/state';
import {updateAssetRequestModal} from '../redux/updateAsset';


export * from './state';

export const assets = combineReducers({
  [ASSETS_PROJECTS_LIST_NAME]: assetsProjectsList.reducers.reducer,
  [CREATE_ASSET_NAME]: createAssetRequestModal.reducers.reducer,
  [DELETE_ASSET_NAME]: deleteAssetRequest.reducers.reducer,
  [UPDATE_ASSET_NAME]: updateAssetRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/assets/reducers/index.js